import { useLang } from "@/contexts/LanguageContext";
import { TRACK_IS_CLOSED, FACEBOOK_URL, INSTAGRAM_URL } from "@/config/trackStatus";

// Reusable next step; disappears automatically when closure mode is switched off.
export default function ClosureInfo({ className = "" }) {
  const { t } = useLang();
  if (!TRACK_IS_CLOSED) return null;
  return <div className={"border border-[#FF2D2D]/40 bg-[#FF2D2D]/5 p-4 text-sm leading-relaxed text-white/75 " + className}>
    <p>{t.closure.availability}</p>
    <p className="mt-2">{t.closure.updates}</p>
    <div className="mt-3 flex flex-wrap gap-4">
      <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="underline underline-offset-4 hover:text-white">Instagram</a>
      <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className="underline underline-offset-4 hover:text-white">Facebook</a>
    </div>
  </div>;
}
